import { render, staticRenderFns } from "./HgFarmerResult.vue?vue&type=template&id=9f4bdf5c&scoped=true"
import script from "./HgFarmerResult.vue?vue&type=script&lang=js"
export * from "./HgFarmerResult.vue?vue&type=script&lang=js"
import style0 from "./HgFarmerResult.vue?vue&type=style&index=0&id=9f4bdf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4bdf5c",
  null
  
)

export default component.exports